import { Paper, Tab, Tabs } from "@mui/material";
import { Box } from "@mui/system";
import { ReactElement, SyntheticEvent } from "react";
import { useDispatch } from "react-redux";
import { ratesTabID } from "../constants";
import { useAppSelector } from "../hooks/hooks";
import JobCategoryRates from "../hooks/jobCategory/jobCategoryRates/jobCategoryRates";
// import { queryBuilder } from "../network";
import { setTabIndex } from "../redux/appStatus/appStatusActions";
import { tabIndexSelector } from "../redux/appStatus/appStatusSelector";
import { useJobCategories } from "../redux/jobCategory/jobCategoryHooks";
import { useProjectTypes } from "../redux/projectType/projectTypeHooks";
import { useScales } from "../redux/scale/scaleHooks";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function RatesRoute(): ReactElement {
  const tabIndex = useAppSelector(tabIndexSelector(ratesTabID)) ?? 0;
  const dispatch = useDispatch();
  const { jobCategories } = useJobCategories();
  const { projectTypes } = useProjectTypes();
  const selectedProjectType = projectTypes ? projectTypes[tabIndex] : undefined;
  const { scales } = useScales();

  // useEffect(() => {
  //   const query = queryBuilder.getQuery();
  //   if (query.tab) {
  //     dispatch(setTabIndex(ratesTabID, parseInt(query.tab)));
  //   }
  // }, []);

  const handleTabIndexChange = (
    _event: SyntheticEvent<Element, Event>,
    v: number
  ) => {
    dispatch(setTabIndex(ratesTabID, v));
  };

  if (!selectedProjectType) return <div />;

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        background: "none",
        flex: 1,
        minWidth: 0,
        gap: 2,
        width: "100%",
        position: "relative",
      }}
    >
      <Paper
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          border: "none",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Paper
          sx={{
            display: "flex",
            position: "sticky",
            top: 48,
            zIndex: 99,
          }}
        >
          <Tabs
            value={tabIndex}
            sx={{ flexGrow: 1 }}
            onChange={handleTabIndexChange}
            aria-label="basic tabs example"
          >
            {(jobCategories ?? []).map((jc) => (
              <Tab label={jc.name} key={jc.id} />
            ))}
          </Tabs>
        </Paper>
        {projectTypes?.length && jobCategories?.length && scales?.length ? (
          <Box
            sx={{
              p: 2,
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              width: "100%",
              overflow: "hidden",
            }}
          >
            <JobCategoryRates jobCategoryID={jobCategories[tabIndex].id} />
          </Box>
        ) : (
          []
        )}
      </Paper>
    </Box>
  );
}
